import { useState, useMemo } from 'react'
import useResizeObserver, { ObservedSize } from 'use-resize-observer'
import { debounce, throttle } from 'lodash'

export const useDebouncedResizeObserver = <T extends Element>(wait: number) => {
  const [size, setSize] = useState<ObservedSize>({ width: undefined, height: undefined })

  const onResize = useMemo(() => debounce(setSize, wait, { leading: true }), [wait])
  const { ref } = useResizeObserver<T>({ onResize })

  return { ref, ...size }
}

export const useThrottledResizeObserver = <T extends Element>(wait: number) => {
  const [size, setSize] = useState<ObservedSize>({ width: undefined, height: undefined })
  const onResize = useMemo(() => throttle(setSize, wait), [wait])
  const { ref } = useResizeObserver<T>({ onResize })

  return { ref, ...size }
}
